var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "job",
    class: {
      'job--with-motto': _vm.show.motto,
        'job--with-date': _vm.show.motto,
    }
  }, [_c('div', {
    staticClass: "job__card"
  }, [_c('a', {
    staticClass: "job__link",
    attrs: {
      "href": _vm.job.url
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "job__logo"
  }, [_c('img', {
    staticClass: "job__logo__image",
    attrs: {
      "src": _vm.job.company.logo,
      "loading": "lazy"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "job__text"
  }, [(_vm.show.date) ? _c('time', {
    staticClass: "job__timestamp",
    attrs: {
      "datetime": _vm.job.updated_at
    }
  }, [_vm._v("\n        " + _vm._s(_vm.updatedAtTimeAgo) + " ago\n      ")]) : _vm._e(), _vm._v(" "), _c('h2', {
    staticClass: "job__title"
  }, [_vm._v("\n        " + _vm._s(_vm.job.title) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "job__company"
  }, [_c('a', {
    staticClass: "job__company__link",
    attrs: {
      "href": _vm.job.company.url
    }
  }, [_c('h3', {
    staticClass: "job__company__name"
  }, [_vm._v("\n            " + _vm._s(_vm.job.company.name) + "\n          ")]), _vm._v(" "), (_vm.show.motto && _vm.job.company.motto) ? _c('span', {
    staticClass: "job__company__motto"
  }, [_vm._v("\n            · " + _vm._s(_vm.job.company.motto) + "\n          ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "job__stats"
  }, [_c('div', {
    staticClass: "job__stat"
  }, [_c('span', {
    staticClass: "job__stat-icon"
  }, [_vm._v("clock")]), _vm._v(" "), _c('span', {
    staticClass: "job__stat-value",
    attrs: {
      "title": _vm.commitment
    }
  }, [_vm._v(_vm._s(_vm.commitment))])]), _vm._v(" "), (_vm.job.remote) ? _c('div', {
    staticClass: "job__stat"
  }, [_c('span', {
    staticClass: "job__stat-icon"
  }, [_vm._v("wifi")]), _vm._v(" "), _c('span', {
    staticClass: "job__stat-value",
    attrs: {
      "title": _vm.translate('remote')
    }
  }, [_vm._v(_vm._s(_vm.translate('remote')))])]) : [(_vm.job.remote_friendly) ? _c('div', {
    staticClass: "job__stat"
  }, [_c('span', {
    staticClass: "job__stat-icon"
  }, [_vm._v("wifi")]), _vm._v(" "), _c('span', {
    staticClass: "job__stat-value",
    attrs: {
      "title": _vm.translate('remote_friendly')
    }
  }, [_vm._v(_vm._s(_vm.translate('remote_friendly')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "job__stat"
  }, [_c('span', {
    staticClass: "job__stat-icon"
  }, [_vm._v("location")]), _vm._v(" "), _c('span', {
    staticClass: "job__stat-value",
    attrs: {
      "title": _vm.job.location
    }
  }, [_vm._v(_vm._s(_vm.job.location))])])]], 2)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3768582c","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/company/job.vue
// module id = null
// module chunks = 